<gp-modal [gp-modal]="modalId" [closable]="true" [hideFooter]="true" (closed)="close()" [form]="true">
  <div class="gp-modal-title">{{ titleKey | translate }}</div>
  <div class="gp-modal-body">
    <i class="fa fa-light fa-spinner fa-spin" aria-hidden="true" *ngIf="loading || !fieldsTree.length"></i>
    <div class="add-field-row" *ngIf="fieldsTree.length">
      <gp-tree-multi-select [config]="treeConfig"
                            [items]="fieldsTree"
                            [inline]="true"
                            test-id="addFieldsTree"
                            [isSorted]="true"
                            [transIdSeperator]="' | '"
                            (selectedChange)="onSelectionChange($event)">
      </gp-tree-multi-select>
      <div class="text-danger small m-t-sm" *ngIf="limitWarningKey as warningKey" test-id="addFieldsLimitWarning">
        <i class="fa fa-light fa-exclamation-triangle" aria-hidden="true"></i>
        {{ warningKey | translate:{maxResult: maxColumns, maxFilter: maxFilters} }}
      </div>
      <div class="add-field-targets m-t-md" [class.single-target]="isSingleTarget">
        <div class="small text-muted m-b-xs" *ngIf="!isSingleTarget" test-id="addFieldsUseAs">
          {{ 'REPORTS.use_fields_as' | translate }}
        </div>
        <div class="btn-group flex">
          <button type="button"
                  *ngIf="showFilterTarget"
                  class="btn m-r-xs"
                  [ngClass]="isSingleTarget ? 'btn-fill-default' : 'btn-outline-default'"
                  test-id="addFieldsFilterBtn"
                  [disabled]="!canAdd('filter')"
                  (click)="addFields('filter')">
            <i class="fa fa-light" [ngClass]="isSingleTarget ? 'fa-plus' : 'fa-bars-filter'" aria-hidden="true"></i>
            {{ (isSingleTarget ? 'NOTIFICATIONS.add' : 'REPORTS.filter') | translate }}
          </button>
          <button type="button"
                  *ngIf="showColumnTarget"
                  class="btn btn-outline-default m-r-xs"
                  test-id="addFieldsColumnBtn"
                  [disabled]="!canAdd('column')"
                  (click)="addFields('column')">
            <i class="fa fa-light fa-columns-3" aria-hidden="true"></i>
            {{ 'REPORTS.column' | translate }}
          </button>
          <button type="button"
                  *ngIf="showBothTarget"
                  class="btn btn-outline-default"
                  test-id="addFieldsBothBtn"
                  [disabled]="!canAdd('both')"
                  (click)="addFields('both')">
            {{ 'REPORTS.both' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</gp-modal>
